import React from "react";
import { ArrowRight } from "lucide-react";
import { SPECTRALOOM_URL, UI } from "@/lib/constants";

export const HeroBanner = ({ lang = "IT" }) => {
  const t = UI[lang];
  return (
    <section
      data-testid="hero-banner"
      className="relative overflow-hidden rounded-2xl border border-violet-500/20 bg-gradient-to-r from-violet-900/40 via-purple-900/25 to-cyan-900/30 backdrop-blur-md p-8 sm:p-12 my-8 fade-up"
    >
      <div className="grain" />
      <div
        className="absolute -top-24 -right-16 w-72 h-72 rounded-full blur-3xl opacity-30"
        style={{ background: "radial-gradient(circle, #8B5CF6, transparent 70%)" }}
      />
      <div
        className="absolute -bottom-24 -left-10 w-72 h-72 rounded-full blur-3xl opacity-25"
        style={{ background: "radial-gradient(circle, #06B6D4, transparent 70%)" }}
      />
      <div className="relative max-w-3xl">
        <span className="inline-block text-xs font-mono uppercase tracking-[0.2em] text-[#06B6D4] mb-4">
          {lang === "IT" ? "Guide • Tutorial • Studio Lab" : "Guides • Tutorials • Studio Lab"}
        </span>
        <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight text-white leading-[1.05]">
          {t.heroHeadline}
        </h1>
        <p className="text-[#CBD5E1] text-base sm:text-lg mt-5 max-w-xl">{t.heroSub}</p>
        <a
          data-testid="hero-cta-button"
          href={SPECTRALOOM_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="group inline-flex items-center gap-2 mt-8 px-7 py-3.5 rounded-full bg-white text-[#0B0D12] font-semibold text-sm hover:bg-[#8B5CF6] hover:text-white transition-colors duration-300"
        >
          {t.heroCta}
          <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
        </a>
      </div>
    </section>
  );
};
